import * as React from 'react';
import styled from 'styled-components';
import { currentBaseUrl, isUserLoggedIn } from 'src/common/services';
import Navbar from '../../components/CustomNav/CustomNav.Component';
import './congratulationsComponent.css';
import { Redirect } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group'
import { currentLesson } from '../../common/services'
// styled subcomponents
const CongratsSVG = styled.svg`
    #animate-path {
        opacity: 1;
        animation: animatePath 2s ease-out;
        animation-iterations-count: infinite;
    }

    @keyframes animatePath {
        from {translateX: 30px}
        to {translateX: 100px}
    }
`

export default class CongratulationsComponent extends React.Component {
    public state = {
        baseUrl: currentBaseUrl(),
        destination: '',
        toLogin: false,
        toProfile: false,
        navigate: false,
        // temporary for modal design
        modalOpen: true,
        rating: 0
    }

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
        this.onProfile = this.onProfile.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onStarClick = this.onStarClick.bind(this);
    }

    public onLogout() {
        // handlelogout
        this.setState({toLogin: true});
    }

    public onProfile() {
        // handle to profile
        this.setState({navigate: true, destination: currentBaseUrl() + "profile" })
    }

    public handleSubmit() {
        // handle submit click event
        // post data to end point
        // routing to the next component
        this.setState({destination: currentBaseUrl() + "lessonsent", navigate: true})
    }

    public closeModal() {
        this.setState({modalOpen: false});
    }

    public onStarClick(nextValue, prevValue, name) {
        this.setState({rating: nextValue});
    }

    public componentDidMount() {
        if(!isUserLoggedIn()){
            this.setState({toLogin: true});
        }
    }

    public render() {
        const lesson = currentLesson();
        console.log("Lesson is: " + JSON.stringify(lesson));

        if(this.state.toLogin === true) {
           return <Redirect to="/login"/>
        }
        if(this.state.navigate === true) {
            return <Redirect to={this.state.destination}/>
        }
        return(
            <div>
                <Navbar profileParent={this.onProfile} logoutParent={this.onLogout} />
                <CSSTransition
                    in={true}
                    appear={true}
                    classNames="fade"
                    timeout={800}
                >
                    <div className="congratulations-container">
                        <h1 className="congratulations-title">Congratulations!</h1>
                        <h2 className="congratulations-description">You have completed {lesson.LessonIdentifier} : {lesson.Title}</h2>

                        <CongratsSVG xmlns="http://www.w3.org/2000/svg" width="229" height="229">
                            <linearGradient x1="86.922%" y1="21.537%" x2="17.306%" y2="79.998%" id="a">
                                <stop stop-color="#3EE9F7" offset="0%" />
                                <stop stop-color="#ACFF24" offset="100%" />
                            </linearGradient>

                            <path id="animate-path" d="M7.387 216.343a5.276 5.276 0 0 0 5.27 5.27c.729 0 1.448-.177 2.117-.469v-20.821l-6.83 13.663a5.275 5.275 0 0 0-.557 2.357zm14.774-30.794v31.934l22.162-11.08v-65.177l-8.797 17.597h1.41v7.386h-5.104l-9.67 19.34zm51.71-103.42l-10.644 21.29h3.257v7.387h-6.95l-7.824 15.646v76.257l22.161-11.081v-109.5zm29.548 50.839h-7.386v-31.712L81.258 86.48v101.453l22.161-11.08v-43.886zm7.388-40.629c-4.074 0-7.388 3.313-7.388 7.387v25.855h29.55c4.073 0 7.386-3.314 7.386-7.388 0-4.073-3.313-7.387-7.387-7.387h-14.775v-11.08a7.394 7.394 0 0 0-7.386-7.387zm29.548 53.239v12.808l8.54-4.269-8.54-8.54zm-22.162-12.61h-7.386v40.192l22.161-11.08v-23.89l-5.223-5.222h-2.164v7.387h-7.388v-7.387zm19.233-.764l23.938 23.937L18.32 227.664A12.758 12.758 0 0 1 12.657 229C5.681 229 0 223.32 0 216.343c0-1.955.462-3.909 1.337-5.659L72.859 67.636 97.9 92.678c2.513-4.58 7.325-7.726 12.907-7.726 8.148 0 14.774 6.626 14.774 14.774v3.694h7.387c8.148 0 14.774 6.626 14.774 14.773 0 6.584-4.356 12.108-10.316 14.01zM29.549 184.677v-7.387h7.387v7.387h-7.387zm0 18.468v-7.387h7.387v7.387h-7.387zm29.548-36.935v-7.387h7.387v7.387h-7.387zm0 18.467v-7.387h7.387v7.387h-7.387zm29.548-29.548v-7.387h7.387v7.387h-7.387zm0 18.468v-7.387h7.387v7.387h-7.387zm-29.548-44.323v-7.387h7.387v7.387h-7.387zm0 18.468v-7.387h7.387v7.387h-7.387zm59.096 11.08v-7.386h7.388v7.386h-7.388zM40.63 81.258c-10.182 0-18.468-8.285-18.468-18.468 0-10.182 8.286-18.467 18.468-18.467a87.273 87.273 0 0 1 43.233 11.482l6.616 3.779-3.665 6.413-6.615-3.779A79.86 79.86 0 0 0 40.629 51.71c-6.108 0-11.08 4.972-11.08 11.08 0 6.109 4.972 11.081 11.08 11.081s11.081-4.972 11.081-11.08v-3.694h7.387v3.693c0 10.183-8.286 18.468-18.468 18.468zM217.92 7.387a3.7 3.7 0 0 0-3.693 3.693 3.7 3.7 0 0 0 3.693 3.694 3.7 3.7 0 0 0 3.694-3.694 3.7 3.7 0 0 0-3.694-3.693zm0 14.775c-6.108 0-11.08-4.972-11.08-11.082 0-6.108 4.972-11.08 11.08-11.08C224.028 0 229 4.972 229 11.08c0 6.11-4.972 11.082-11.08 11.082zm-43.24 26.936l14.774-14.774 5.223 5.223-14.774 14.774-5.223-5.223zm-40.63 40.63l33.241-33.242 5.223 5.222L139.27 94.95l-5.223-5.223zm59.096-59.097l7.387-7.386 5.223 5.223-7.385 7.385-5.225-5.222zm-38.016-1.083c-8.148 0-14.774-6.626-14.774-14.774S146.98 0 155.129 0s14.774 6.626 14.774 14.774c0 12.895-5.022 25.02-14.142 34.14l-9.101 9.1-5.223-5.222 9.1-9.1c7.725-7.729 11.979-17.996 11.979-28.918 0-4.074-3.313-7.387-7.387-7.387s-7.387 3.313-7.387 7.387 3.313 7.387 7.387 7.387v7.387zm25.855-11.08V11.08h7.387v7.387h-7.387zm-73.794 18.02c-5.917 5.733-15.527 5.73-21.437-.004-2.899-2.805-4.495-6.555-4.495-10.545 0-3.988 1.596-7.733 4.498-10.545 5.91-5.73 15.525-5.727 21.434 0 9.475 9.186 14.697 21.415 14.697 34.424V62.79H114.5V49.818c0-10.994-4.42-21.337-12.451-29.123-3.08-2.981-8.078-2.985-11.151 0-1.456 1.407-2.253 3.268-2.253 5.244 0 1.977.797 3.839 2.25 5.245 3.076 2.981 8.074 2.978 11.15 0l5.145 5.304zm-7.464 33.69V62.79h7.387v7.387h-7.387zm114.5-11.081c8.148 0 14.774 6.626 14.774 14.774s-6.626 14.774-14.774 14.774-14.775-6.626-14.775-14.774h7.388c0 4.074 3.313 7.387 7.387 7.387s7.387-3.313 7.387-7.387-3.313-7.387-7.387-7.387c-10.922 0-21.19 4.254-28.917 11.98l-9.1 9.099-5.223-5.223 9.1-9.1c9.12-9.12 21.245-14.143 34.14-14.143zm-3.694-11.081v-7.387h7.387v7.387h-7.387zm-99.725-40.63V0h7.386v7.387h-7.386zm58.61 131.136l3.778 6.612a87.293 87.293 0 0 1 11.483 43.237c0 10.183-8.286 18.468-18.468 18.468s-18.468-8.285-18.468-18.468c0-10.182 8.286-18.468 18.468-18.468h3.693v7.388h-3.693c-6.109 0-11.081 4.972-11.081 11.08s4.972 11.081 11.08 11.081c6.11 0 11.081-4.973 11.081-11.081a79.863 79.863 0 0 0-10.508-39.569l-3.779-6.615 6.413-3.665zm44.192-16.709c5.728 5.91 5.728 15.524-.003 21.434-2.808 2.899-6.553 4.495-10.546 4.495-3.992 0-7.738-1.596-10.548-4.495-5.73-5.91-5.73-15.524 0-21.434l5.304 5.145c-2.981 3.074-2.981 8.075 0 11.148 2.813 2.907 7.67 2.902 10.486 0 2.98-3.077 2.98-8.078 0-11.151-7.786-8.034-18.126-12.455-29.12-12.455H166.21v-7.387h12.976c13.008 0 25.235 5.222 34.423 14.7zm-54.786 7.461v-7.387h7.387v7.387h-7.387zm62.79-11.08v-7.387H229v7.386h-7.387zm-11.081 70.176v-7.386h7.387v7.386h-7.387zM40.629 18.467V11.08h7.387v7.387h-7.387z" fill="url(#a)" fill-rule="nonzero" />
                        </CongratsSVG>

                        <p>Please, submit the lesson to know your results</p>
                        <button className="congratulations-submit-lesson green-button" onClick={this.handleSubmit}>Submit</button>

                    </div>
                </CSSTransition>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/pages/Feedback/congratulations.Component.tsx